import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'select-home',
    templateUrl: './select-home.component.html',
    styleUrls: ['./select-home.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule],
})
export class SelectHomeComponent {
    @Input() options: { value: any; label: string }[] = [];
    @Input() label: string = '';
    @Input() currentValue: string = '';
    @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() mandatoryField: boolean = false;

    isDropdownOpen: boolean | string = false;

    getCurrentLabel() {
        return this.options.find((option) => option.value === this.currentValue)
            ?.label;
    }

    toggleDropdown(e) {
        if (this.isDropdownOpen === e) {
            this.closeDropdown();
            return;
        }
        this.isDropdownOpen = e;
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    selectOption(option: any) {
        this.selectionChange.emit(option.value);
        this.closeDropdown();
    }
}
